/*
  Domain Helper
  Detects which brand experience should be rendered based on the hostname.
  The TOG (Transova) domain gets its own login splash page; every other
  domain (Vytelle / Sense) keeps the current experience.
*/

// Domains served by the TOG (Transova) brand experience
const TOG_DOMAINS = ["advance.transova.com"];

export const isTogDomain = () => {
  const hostName = window.location.hostname || "";

  if (TOG_DOMAINS.includes(hostName.toLowerCase())) {
    return true;
  }

  // Local/dev override, e.g. http://localhost:3000/login?brand=transova
  const brand = new URLSearchParams(window.location.search).get("brand");
  return brand === "transova";
};

export default {
  isTogDomain,
};
